import { Box, Grid, useTheme } from "@mui/material";
import {
	DATA_ROLE_SCREEN_SLUG,
	INITIAL_PAGE_SIZE,
	INITIAL_SNACKBAR_DATA,
	ROWS_PER_PAGE_PER_OPTIONS,
} from "../../../common/constants";
import {
	DeleteConfirmationDialog,
	EmptyList,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	RouterLinkButton,
} from "@websential/cosmic-v20";
import React, { useCallback, useEffect, useState } from "react";
import {
	setSelectedActivityLogActions,
	setSelectedStickyNavBar,
} from "../../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { DataRoleService } from "../../../services/DataRoleService";
import { IAppState } from "../../../store/reducers";
import { IGetListRequest } from "../../../models";
import { PrimeDataGrid } from "../../PrimeDataGrid";
import { setSelectedDrawerOptionsMenu } from "../../../store/actions/drawerMenuOptionsActions";
import { useNavigate } from "react-router-dom";

export interface IDataRoleList { }
const DATA_ROLE_LIST_QUERY_KEY: any = "data-roles-list";

const useDataRoles = (params: IGetListRequest) =>
	useQuery({
		queryKey: [DATA_ROLE_LIST_QUERY_KEY, params],
		queryFn: (data) => {
			return DataRoleService.getList(params);
		},
		refetchOnWindowFocus: false,
	});

export const DataRoleList: React.FC<IDataRoleList> = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	// for delete row Purpose
	const queryClient = useQueryClient();
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);

	const [queryParams, setQueryParams] = useState<IGetListRequest>({
		search_query: "",
		order_by: "role_name",
		order_direction: "asc",
		page: 1,
		size: INITIAL_PAGE_SIZE,
	});

	const { isPending, data } = useDataRoles(queryParams); //useQuery('accountants-list', AccountantService.getAccountantList, { refetchOnWindowFocus: false });
	const dataRolesList: any = data;


	const { message, componentState } = useSelector(
		(state: IAppState) => state.viewState
	);

	// const { accountantList } = useSelector(
	//   (state: IAppState) => state.accountant
	// );

	const [openDialog, setDialogOpen] = useState(false);
	const [selectedIds, setSelectedIds] = useState([]);
	const [statusValue, setStatusValue] = useState("");
	const [apiAction, setApiAction] = useState("");
	const [emptyList, setEmptyList] = useState(false);

	// for delete row
	const [singleDelete, setSingleDelete] = useState<boolean>(false);
	const [dataRoleId, setDataRoleId] = useState<number>(0);

	const onRequestParamsChange = useCallback((requestParams: any) => {

		let dispatchParams = {
			search_query: requestParams.searchQuery ? requestParams.searchQuery : "",
			order_by: "firstName",
			order_direction: requestParams.sortOrder
				? requestParams.sortOrder
				: "asc",
			page: requestParams.page + 1,
			size: requestParams.rows,
		};

		setQueryParams(dispatchParams);
	}, []);

	const onRowEditClicked = useCallback((params: any) => {
		let path = `/roles/setup/${params.row.id}`;
		navigate(path);
	}, []);

	const onCloseHandler = () => {
		setDialogOpen(false);
	};

	const callAction = () => {
		if (apiAction === "delete") {
			alert(`Delete row with ID: ${selectedIds} has been clicked!`);
			// TODO api call for delete
		} else if (apiAction === "updateStatus") {
			alert(`action need to trigger : ${apiAction}`);
			// TODO api call for update status
		}
		setDialogOpen(false);
	};

	// For Delete Row
	const deleteDataRoleField = () => {
		if (singleDelete) {
			setSingleDelete(false);
			deleteDataRoleById(dataRoleId);
			setDialogOpen(false);
		}
	};

	const onRowDeleteClicked = useCallback((params: any) => {
		setDialogOpen(true);
		setSingleDelete(true);
		setApiAction("delete");
		setDataRoleId(params.row.id);

		// alert(`Delete row with ID: ${params.row.id} has been clicked!`);
	}, []);

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const { isPending: isDeleting, mutate: deleteDataRoleById } = useMutation({
		mutationFn: DataRoleService.delDataRole,
		onSuccess: (res: string | IServerError | IResponse) => {
			if (typeof res === "string") {
				// remove the cache of the Year fields since we just added a new field.
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});

				return queryClient.invalidateQueries(DATA_ROLE_LIST_QUERY_KEY);
			} else {
				setSnackbarData({
					open: true,
					message: "Something went wrong, try again later!",
					severity: "error",
				});
			}
		},
		onError: (err) => {
			// TODO: customize the toast message based on the response
			setSnackbarData({
				open: true,
				message: "Something went wrong, try again later!",
				severity: "error",
			});
		},
	});

	// const onKeyFieldClickHandler = (clickedRow: any) => {
	//   dispatch(setSelectedDataRole(clickedRow));
	// };

	const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
		setStatusValue(event.target.value as string);
		setApiAction("updateStatus");
		setDialogOpen(true);
	};

	const selectionToolbar = useCallback((selectedItems: any) => {
		setSelectedIds(selectedItems);
		if (selectedItems.length) {
			return (
				<Box sx={{ marginTop: theme.spacing(1) }}>
					{"Bulk Action Drop Down List"}
					{/* <EnhancedDDLBulkAction
            label="Status"
            value={statusValue}
            onChangeHandler={handleChange}
            options={[
              { name: "Active", value: "1" },
              { name: "Inactive", value: "2" },
            ]}
            testId="status-dd"
          /> */}
				</Box>
			);
		}
		return (
			<Box sx={{ marginTop: theme.spacing(1) }}>
				<RouterLinkButton to="/roles/setup" text="Add Data Role" />
			</Box>
		);
	}, []);

	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);

	const expandedLabels = ["Misc.", "Data Roles"];
	const expandedBanckListItem = "List";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Data Roles" &&
				item.label === expandedBanckListItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: isExpanded,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
			};
			return enhancedItem;
		});
	};

	useEffect(() => {
		dispatch(
			setSelectedActivityLogActions({
				entityId1: "",
				entityId2: "",
				entityId3: "",
				screenName: DATA_ROLE_SCREEN_SLUG,
				companyName: "",
				activityType: "activity_type=delete",
				activityLogVisibility: true,
			})
		);
		dispatch(setSelectedStickyNavBar({ isSticky: false }));
		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);

	const image =
		"https://taxslips.blob.core.windows.net/taxslips-public-images-container/empty_employee_list.png";

	return dataRolesList &&
		dataRolesList.items &&
		dataRolesList.items.length === 0 ? (
		<EmptyList
			showImage={true}
			imagePath={image}
			heading={`There's nothing! Add Data Role to proceed`}
			content={`You can add data role by directly clicking on add data role button.`}
			testId={"Data Role-empty-list"}
			showAddButton={true}
			addButtonLabel={"Add Data Role"}
			navigateToAdd={"/roles/setup"}
			showImportButton={false}
			showImportXmlButton={false}
		/>
	) : (
		<>
			<Grid
				size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
				sx={{ width: "100%" }}
			>
				<DeleteConfirmationDialog
					open={openDialog}
					deleteActionHandler={deleteDataRoleField}
					cancelActionHandler={onCloseHandler}
					testId="data-role-field-tab-confirmation-dialog"
				/>
				<PrimeDataGrid
					columns={dataRolesList ? dataRolesList.headerColumns : []}
					rows={dataRolesList?.items}
					showIndexColumn={true}
					showChecboxColumn={true}
					showSettingColumn={true}
					onRowEditClicked={onRowEditClicked}
					onRowDeleteClicked={onRowDeleteClicked}
					isLoading={
						isPending || isDeleting
						// || isBulkDeleting
					}
					onSnackbarMessageData={(value: any) => setSnackbarData(value)}
					totalRecords={
						dataRolesList && dataRolesList.total ? dataRolesList.total : 0
					}
					initialPageSize={INITIAL_PAGE_SIZE}
					rowsPerPageOptions={ROWS_PER_PAGE_PER_OPTIONS}
					onRequestParamsChange={onRequestParamsChange}
					selectionToolbar={selectionToolbar}
					// selectedRowsValues={(value: any) => setSelectedRowsValues(value)}
					searchFieldPlaceholder={"Search by Year..."}
				// changeLoginForGetEmptyItemsBySearchQuery={(value: any) =>
				//   setzeroCountry(value)
				// }
				/>
			</Grid>
			<EnhancedSnackbar
				message={snackbarData.message}
				onCloseHandler={onSnackbarClosed}
				severity={snackbarData.severity}
				testId={"data-role-field-tab-list-snackbar"}
				open={snackbarData.open}
			/>
		</>
	);
};
